import { DateTime } from 'luxon';

import ActivityEvent from './ActivityEvent';

/**
 * One alert in the school's history, as GET /alerts and GET /alerts/:id serve
 * it. A detail read also carries the timeline and, for an Emergency, what was
 * dispatched.
 */
export default class Incident {
  static thaw(obj) {
    if (obj == null) return null;
    const incident = new Incident();
    incident.id = obj.id ?? null;
    incident.status = obj.status ?? null;
    incident.isDrill = obj.isDrill === true;
    incident.isSchoolWide = obj.isSchoolWide === true;
    incident.isActive = obj.isActive === true;
    incident.title = obj.title ?? '';
    incident.startedAt = obj.startedAt ? DateTime.fromISO(obj.startedAt) : null;
    incident.endedAt = obj.endedAt ? DateTime.fromISO(obj.endedAt) : null;
    incident.durationSeconds = obj.durationSeconds ?? null;
    incident.source = obj.source ?? null;
    incident.raisedBy = obj.raisedBy ?? null;
    incident.room = obj.room ?? null;
    incident.timeline = obj.timeline ? ActivityEvent.thawList(obj.timeline) : null;
    // { note, rows: [{ channel, detail, state, tone, at }] }, or null when the
    // status does not dispatch.
    incident.dispatch = obj.dispatch ?? null;
    return incident;
  }

  static thawList(list) {
    return (list ?? []).map((obj) => Incident.thaw(obj));
  }

  getID() {
    return this.id;
  }

  /** The status name, e.g. "Emergency". */
  getStatus() {
    return this.status;
  }

  getIsDrill() {
    return this.isDrill;
  }

  getIsSchoolWide() {
    return this.isSchoolWide;
  }

  /** Still in force. */
  getIsActive() {
    return this.isActive;
  }

  getTitle() {
    return this.title;
  }

  getStartedAt() {
    return this.startedAt;
  }

  getEndedAt() {
    return this.endedAt;
  }

  getDurationSeconds() {
    return this.durationSeconds;
  }

  /** Where it was raised: "Dashboard", or "Badge BDG-1140 in Room 120". */
  getSource() {
    return this.source;
  }

  getRaisedBy() {
    return this.raisedBy;
  }

  getRoom() {
    return this.room;
  }

  getTimeline() {
    return this.timeline;
  }

  getDispatch() {
    return this.dispatch;
  }
}
